import * as React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Header from "../components/common/header/Header";
import { Article } from "../interfaces/Article";
import Stack from "@mui/material/Stack";
import Footer from "../components/common/Footer/Footer";
import Pagination from "@mui/material/Pagination";
import theme from "../theme";
import { Typography, Breadcrumbs, Container } from "@mui/material";
import { getBatteryProducts } from "../services/core-api";
import LocalProductItem from "../components/products/LocalProductItem";

const BatterySearchPage = () => {
   const [articles, setArticles] = React.useState<Article[]>([]);
   const [ampher, setampher] = React.useState('');
   const [brand, setBrand] = React.useState('');
   const [page, setPage] = React.useState(1);
   const [count, setCount] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const loading = articles.length === 0;
  const [isWrongPath, setIsWrongPath] = React.useState(false);

 const isFirstRun = React.useRef(true);

  React.useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      const urlParams = new URLSearchParams(window.location.search);
      const ampherParam = urlParams.get("ampher");
      const brandIdParam = urlParams.get("brand");

      if (ampherParam == null) {
         setTimeout(() => {
            setIsWrongPath(true)
         }, 1000);
      }

      if (ampherParam){
         setampher(ampherParam);
      }

      if (brandIdParam) {
         setBrand(brandIdParam);
      }
    }
    }, []);

    React.useEffect(() => {
     
         (async () => {
            try {
               const options: {
                  ampher: string;
                  page_number: number;
                  brand?: string; 
                } = {
                  ampher: ampher,
                  page_number: page,
                };
        
                
                if (brand) {
                  options.brand = brand;
                }
               const response = await getBatteryProducts(options);
               if (response) {
                  setCount( Math.ceil(response.total / rowsPerPage));
                  setArticles(response.batteries);
               }
            } catch (error) {
            }
         })()
    },[brand, ampher, page, rowsPerPage]);

    const handlePageChange = (
      event: React.ChangeEvent<unknown>,
      page: number
    ) => {
      setPage(page);
      window.scrollTo({
        top: 100,
        left: 100,
        behavior: "smooth",
      });
    };

return (
   <>
      <Header/>
         <Box
          sx={{
            flexGrow: 1,
            m: 2,
            minHeight: '71vh',
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: '100vh'
          }}
        >
         <Container maxWidth="lg">
            <Grid container spacing={3}>
            <Grid item xs={12} sm={12}>
               <Box
                sx={{
                  bgcolor: "#f1f1f1",
                  paddingTop: '10px',
                  paddingBottom: '10px',
                  paddingLeft: 1,
                  borderTop: `2px solid ${theme.palette.primary.dark}`,
                }}
               >
                  <Grid container spacing={1}>
                     <Grid item xs={12} sm={12} md={5} sx={{paddingLeft: '0px !important', }}>
                        <Stack spacing={2} sx={{paddingTop: '3px', paddingLeft: '5px'}}>
                           <Breadcrumbs aria-label="breadcrumb">
                              <Typography key="3"
                                 sx={{
                                    color: theme.palette.text.primary,
                                    fontWeight: 600,
                                    fontSize: "15px",
                                    fontFamily: "Inter",
                                 }}
                              >
                                 Products
                              </Typography>
                           </Breadcrumbs>
                        </Stack>
                     </Grid>
                  </Grid>
               </Box>
               <Box sx={{ mt: 4 }}>
               {articles.map((article, index) => (
                    <LocalProductItem key={index} article={article} />
                ))}
               </Box>
            </Grid>
            </Grid>
         </Container>
         <Stack spacing={2} sx={{ pt: 2 }}>
            <Pagination
              count={count}
              page={page}
              variant="outlined"
              shape="rounded"
              onChange={handlePageChange}
            />
          </Stack>
        </Box>
      <Footer/>
   </>
)
}
export default BatterySearchPage;
